// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { BooleanField, FormType, NumberField, TextField } from "@hex-insights/forms";
import { ReportCardSectionPolicyFormValues } from "../../FormUtilities";
import { CourseSectionSelectField } from "../CourseSection";
import { HomeRoomSectionSelectField } from "../HomeRoomSection";
import { MarkingSystemSelectField } from "../MarkingSystem";
import { BaseFieldProps } from "../shared";

/**
 * Generic props for fields of the ReportCardSectionPolicy model.
 */
type FieldProps<K extends keyof ReportCardSectionPolicyFormValues.Base = keyof ReportCardSectionPolicyFormValues.Base> =
	BaseFieldProps<Pick<ReportCardSectionPolicyFormValues.Base, K>>;

/**
 * Field component for the `nameSuffix` field of the ReportCardSectionPolicy model.
 */
export function NameSuffix({ formState, ...props }: FieldProps<"nameSuffix">) {
	return <TextField formState={formState} name="nameSuffix" optional {...props} />;
}

/**
 * Field component for the `usesDescription` field of the ReportCardSectionPolicy model.
 */
export function UsesDescription({ formState, ...props }: FieldProps<"usesDescription">) {
	return <BooleanField formState={formState} name="usesDescription" {...props} />;
}

/**
 * Field component for the `descriptionLabel` field of the ReportCardSectionPolicy model.
 */
export function DescriptionLabel({ formState, ...props }: FieldProps<"descriptionLabel">) {
	return <TextField formState={formState} name="descriptionLabel" optional {...props} />;
}

/**
 * Field component for the `description` field of the ReportCardSectionPolicy model.
 */
export function Description({ formState, ...props }: FieldProps<"description">) {
	return <TextField formState={formState} name="description" multiLine optional {...props} />;
}

/**
 * Field component for the `usesOverallMark` field of the ReportCardSectionPolicy model.
 */
export function UsesOverallMark({ formState, ...props }: FieldProps<"usesOverallMark">) {
	return <BooleanField formState={formState} name="usesOverallMark" {...props} />;
}

/**
 * Field component for the `overallMarkLabel` field of the ReportCardSectionPolicy model.
 */
export function OverallMarkLabel({ formState, ...props }: FieldProps<"overallMarkLabel">) {
	return <TextField formState={formState} name="overallMarkLabel" optional {...props} />;
}

/**
 * Field component for the `isOverallMarkManual` field of the ReportCardSectionPolicy model.
 */
export function IsOverallMarkManual({ formState, ...props }: FieldProps<"isOverallMarkManual">) {
	return <BooleanField formState={formState} name="isOverallMarkManual" {...props} />;
}

/**
 * Field component for the `usesComment` field of the ReportCardSectionPolicy model.
 */
export function UsesComment({ formState, ...props }: FieldProps<"usesComment">) {
	return <BooleanField formState={formState} name="usesComment" {...props} />;
}

/**
 * Field component for the `commentLabel` field of the ReportCardSectionPolicy model.
 */
export function CommentLabel({ formState, ...props }: FieldProps<"commentLabel">) {
	return <TextField formState={formState} name="commentLabel" optional {...props} />;
}

/**
 * Field component for the `minCommentLength` field of the ReportCardSectionPolicy model.
 */
export function MinCommentLength({ formState, ...props }: FieldProps<"minCommentLength">) {
	return (
		<NumberField
			formState={formState}
			name="minCommentLength"
			optional={FormType.isCreate(formState.formType)}
			validationUnit={1}
			{...props}
		/>
	);
}

/**
 * Field component for the `maxCommentLength` field of the ReportCardSectionPolicy model.
 */
export function MaxCommentLength({ formState, ...props }: FieldProps<"maxCommentLength">) {
	return (
		<NumberField
			formState={formState}
			name="maxCommentLength"
			optional={FormType.isCreate(formState.formType)}
			validationUnit={1}
			{...props}
		/>
	);
}

/**
 * Field component for the `isForHomeRoomSection` field of the ReportCardSectionPolicy model.
 */
export function IsForHomeRoomSection({ formState, ...props }: FieldProps<"isForHomeRoomSection">) {
	return <BooleanField formState={formState} name="isForHomeRoomSection" {...props} />;
}

/**
 * Field component for the `usesGeneralComments` field of the ReportCardSectionPolicy model.
 */
export function UsesGeneralComments({ formState, ...props }: FieldProps<"usesGeneralComments">) {
	return <BooleanField formState={formState} name="usesGeneralComments" {...props} />;
}

/**
 * Field component for the `minGeneralComment1Length` field of the ReportCardSectionPolicy model.
 */
export function MinGeneralComment1Length({ formState, ...props }: FieldProps<"minGeneralComment1Length">) {
	return (
		<NumberField
			formState={formState}
			name="minGeneralComment1Length"
			optional={FormType.isCreate(formState.formType)}
			validationUnit={1}
			{...props}
		/>
	);
}

/**
 * Field component for the `maxGeneralComment1Length` field of the ReportCardSectionPolicy model.
 */
export function MaxGeneralComment1Length({ formState, ...props }: FieldProps<"maxGeneralComment1Length">) {
	return (
		<NumberField
			formState={formState}
			name="maxGeneralComment1Length"
			optional={FormType.isCreate(formState.formType)}
			validationUnit={1}
			{...props}
		/>
	);
}

/**
 * Field component for the `minGeneralComment2Length` field of the ReportCardSectionPolicy model.
 */
export function MinGeneralComment2Length({ formState, ...props }: FieldProps<"minGeneralComment2Length">) {
	return (
		<NumberField
			formState={formState}
			name="minGeneralComment2Length"
			optional={FormType.isCreate(formState.formType)}
			validationUnit={1}
			{...props}
		/>
	);
}

/**
 * Field component for the `maxGeneralComment2Length` field of the ReportCardSectionPolicy model.
 */
export function MaxGeneralComment2Length({ formState, ...props }: FieldProps<"maxGeneralComment2Length">) {
	return (
		<NumberField
			formState={formState}
			name="maxGeneralComment2Length"
			optional={FormType.isCreate(formState.formType)}
			validationUnit={1}
			{...props}
		/>
	);
}

export namespace CourseSection {
	export type SelectProps = FieldProps<"courseSectionID"> &
		Omit<
			CourseSectionSelectField.SelectProps<ReportCardSectionPolicyFormValues.Base>,
			"formState" | "name" | "optional"
		>;

	/**
	 * Field component for the `courseSection` edge of the ReportCardSectionPolicy model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <CourseSectionSelectField.Select formState={formState} name="courseSectionID" optional {...props} />;
	}
}

export namespace HomeRoomSection {
	export type SelectProps = FieldProps<"homeRoomSectionID"> &
		Omit<
			HomeRoomSectionSelectField.SelectProps<ReportCardSectionPolicyFormValues.Base>,
			"formState" | "name" | "optional"
		>;

	/**
	 * Field component for the `homeRoomSection` edge of the ReportCardSectionPolicy model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <HomeRoomSectionSelectField.Select formState={formState} name="homeRoomSectionID" optional {...props} />;
	}
}

export namespace OverallMarkingSystem {
	export type SelectProps = FieldProps<"overallMarkingSystemID"> &
		Omit<
			MarkingSystemSelectField.SelectProps<ReportCardSectionPolicyFormValues.Base>,
			"formState" | "name" | "optional"
		>;

	/**
	 * Field component for the `overallMarkingSystem` edge of the ReportCardSectionPolicy model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <MarkingSystemSelectField.Select formState={formState} name="overallMarkingSystemID" optional {...props} />;
	}
}
